//#region src/v2/blocks/request-block/helpers/group-global-cookies.ts
/**
* Groups global cookies by name so duplicate names collapse into a single row. Same-named cookies
* used to render as independent rows that all shared one disabled state, so toggling one toggled
* them all. Grouping them lets a name expose its values as a preset switcher instead.
*
* The `shouldInclude` predicate applies the caller's domain and path filtering while the original
* index is still known, so a selection can be written back to the right entry. That predicate
* deliberately ignores the disabled flag for preset values: a disabled value is only hidden from
* the request, not from the switcher, so the user can select it again.
*/
var groupGlobalCookies = ({ sources, shouldInclude }) => {
	/** Names in first-seen order so the rendered rows keep a stable, predictable order. */
	const order = [];
	const grouped = /* @__PURE__ */ new Map();
	for (const { location, cookies } of sources) cookies.forEach((cookie, index) => {
		if (!cookie.name || !shouldInclude(cookie)) return;
		if (!grouped.has(cookie.name)) {
			grouped.set(cookie.name, []);
			order.push(cookie.name);
		}
		grouped.get(cookie.name)?.push({
			location,
			value: cookie.value,
			isDisabled: cookie.isDisabled ?? false,
			index
		});
	});
	const groups = [];
	for (const name of order) {
		const entries = grouped.get(name) ?? [];
		const first = entries[0];
		if (!first) continue;
		const enabled = entries.filter((entry) => !entry.isDisabled);
		const options = [...new Set(entries.map((entry) => entry.value))];
		const isPreset = options.length > 1;
		if (!isPreset && enabled.length === 0) continue;
		groups.push({
			name,
			selectedValue: (enabled[0] ?? first).value,
			options: isPreset ? options : [],
			isPreset,
			location: first.location,
			siblings: entries.map(({ location, index, value }) => ({
				location,
				index,
				value
			}))
		});
	}
	return groups;
};
//#endregion
export { groupGlobalCookies };

//# sourceMappingURL=group-global-cookies.js.map